import Icon from './arrow-left.svg?react'
import { createIcon } from './factory'

export const ArrowLeft = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
